import { Section } from '@/shared/components/ui/Section'
import { Table } from '@/shared/components/ui/Table'
import { useTranslation } from '@/shared/i18n/useTranslation'
import { SurvivorPickResult, type SurvivorPickHistoryEntry } from '../types'
import { PickResultBadge } from './PickResultBadge'
import styles from './SurvivorHistory.module.css'

export function SurvivorHistory({ picks }: { picks: SurvivorPickHistoryEntry[] }) {
  const { t } = useTranslation()

  if (picks.length === 0) {
    return (
      <Section label={t('survivor.history.title')}>
        <p className={styles.empty}>{t('survivor.history.empty')}</p>
      </Section>
    )
  }

  return (
    <Section label={t('survivor.history.title')} meta={picks.length}>
      <Table label={t('survivor.history.title')}>
        <tbody>
          {picks.map((pick) => {
            const isForfeit = pick.result === SurvivorPickResult.Forfeit || !pick.teamCode
            return (
              <Table.Row key={pick.pickId}>
                <Table.Cell isMuted className={styles.roundCell}>
                  {t('survivor.round.short', { number: pick.gameweekNumber })}
                </Table.Cell>
                <Table.Cell>
                  {isForfeit ? (
                    <span className={styles.noPick}>{t('survivor.pick.none')}</span>
                  ) : (
                    pick.teamName
                  )}
                </Table.Cell>
                <Table.Cell className={styles.resultCell}>
                  <PickResultBadge result={pick.result} />
                </Table.Cell>
              </Table.Row>
            )
          })}
        </tbody>
      </Table>
    </Section>
  )
}
